<div class="m-container padding-top">
	<div class="m-grid__item m-grid__item--fluid m-wrapper marginTop">
		<!-- END: Subheader -->
		<div class="m-content">
			<!--begin::Portlet-->
			<div class="m-portlet m-portlet--tab">
				<div class="row content-padding">
					<div class="col-md-12">
						<div class="m-portlet__head">
							<div class="m-portlet__head-caption">
								<div class="row">
									<div class="col-md-10 col-lg-10">
										<div class="m-portlet__head-10itle"> <span class="m-portlet__head-icon m--hide">
												<i class="la la-gear"></i>
											</span>
											<h4 class="m-form__heading-title form-subhead-label-style subheader">
												Residential Facilities
											</h4>
										</div>
									</div>
									<div class="col-md-2 col-lg-2">
										<div class="m-portlet__head-title title-right"> <span
												class="m-portlet__head-icon m--hide">
												<i class="la la-gear"></i>
											</span>
											<button class="btn btn-next" (click)="previous()">Previous</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="col-md-10" style="padding-left: 50px; padding-top: 29px">
						<label style="float:right">(<span
							class="mandatory">*</span> is mandatory)</label>
						<form [formGroup]="homePageFormGroup">
							<div class="row form-group cot-spacing">
								<label class="text-align col-4">Name of Training Partner: <span
										class="mandatory">*</span>
								</label>
								<div class="col-8">
									<input type="text"
										[ngModel]="userDetails && userDetails.trainingPartner &&userDetails.trainingPartner.name"
										[ngModelOptions]="{standalone: true}"
										class="form-control m-input text-side-padding" disabled>
									<!-- <span>Minimum Cot Length to be 6 ft</span> -->
								</div>
							</div>
							<div class="row form-group cot-spacing">
								<label class="text-align col-4">Training Partner ID: <span class="mandatory">*</span>
								</label>
								<div class="col-8">
									<input type="text"
										[ngModel]="userDetails && userDetails.trainingPartner &&userDetails.trainingPartner.userName"
										[ngModelOptions]="{standalone: true}" disabled
										class="form-control m-input text-side-padding">
									<!-- <span>Minimum Cot Length to be 6 ft</span> -->
								</div>
							</div>
							<div class="row form-group cot-spacing">
								<label class="text-align col-4">Name of Training Center: <span
										class="mandatory">*</span>
								</label>
								<div class="col-8">
									<input type="text" [ngModel]="userDetails && userDetails.trainingCentreName"
										[ngModelOptions]="{standalone: true}"
										class="form-control m-input text-side-padding" disabled>
									<!-- <span>Minimum Cot Length to be 6 ft</span> -->
								</div>
							</div>
							<div class="row form-group cot-spacing">
								<label class="text-align col-4">Training Center ID: <span class="mandatory">*</span>
								</label>
								<div class="col-8">
									<input type="text" [ngModel]="userDetails && userDetails.userName"
										[ngModelOptions]="{standalone: true}"
										class="form-control m-input text-side-padding" disabled>
									<!-- <span>Minimum Cot Length to be 6 ft</span> -->
								</div>
							</div>
							<div class="row form-group cot-spacing">
								<label class="text-align col-4">Name of Residential Facility: <span
										class="mandatory">*</span>
								</label>
								<div class="col-8">
									<input type="text" formControlName="nameOfResidentialFacility" maxlength="200"
										class="form-control m-input text-side-padding" disabled>
									<app-form-control-messages
										[control]="homePageFormGroup.get('nameOfResidentialFacility')"
										[name]="'Please Enter Name of Residential Facility'"
										[errorMessages]="{pattern:'You can not enter number in  Name of the Residential Facility'}"></app-form-control-messages>
									<!-- <span>Minimum Cot Length to be 6 ft</span> -->
									<!-- You can not enter number in Name of the Residential Facility -->
								</div>

							</div>
							<div class="row form-group cot-spacing">
								<label class="col-4 text-align-ment">Availability of Display Board at front of the
									building mentioning Training Centre/Hostel Name: <span class="mandatory">*</span>
								</label>
								<div class="select-div col-8">
									<div class="form-select-side">
										<svg width="10px" height="12px" version="1.1" xmlns="http://www.w3.org/2000/svg"
											viewBox="0 0 129 129" enable-background="new 0 0 129 129">
											<g>
												<path
													d="m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z">
												</path>
											</g>
										</svg>
									</div>
									<select class="form-control m-input" id="exampleSelect1" disabled
										formControlName="availabilityOfDisplayBoardFrontBuild" >
										<option value=null disabled>Select Availability of Display Board at front of the
											building</option>
										<option [ngValue]="true">Yes</option>
										<option [ngValue]="false">No</option>
									</select>
									<app-form-control-messages
										[control]="homePageFormGroup.get('availabilityOfDisplayBoardFrontBuild')"
										[name]="'Availability of Display Board at front of the building'">
									</app-form-control-messages>
								</div>
							</div>
							<div class="row form-group cot-spacing">
								<label class="text-align col-4"><b>Total Area :</b>
									<!-- <span class="mandatory">*</span> -->
								</label>
								<div class="col-8">
									<input type="number" formControlName="totalArea"
										class="form-control m-input text-side-padding" disabled> <span>Total Area auto
										calculated</span>
									<!-- <span>Minimum Cot Length to be 6 ft</span> -->
								</div>
							</div>
							<div class="row form-group cot-spacing">
								<label class="text-align col-4"><b>Total Capacity:</b>
									<!-- <span class="mandatory">*</span> -->
								</label>
								<div class="col-8">
									<input type="number" formControlName="totalCapacity"
										class="form-control m-input text-side-padding" disabled> <span>Total Capacity
										auto calculated</span>
									<!-- <span>Minimum Cot Length to be 6 ft</span> -->
								</div>
							</div>
						</form>
						<app-d-form-group [fnBuffer]="buffer" *ngIf="formDataLoaded"
							[(formData)]="typeOfResidencialData" (formLoaded)="onFormLoaded()"
							[formArray]="typeOfResidencialForm" [defaultValues]="typeOfResidentialInitialDefault"
							(validChange)="validity.typeOfResidencial = $event"></app-d-form-group>
					</div>
					<!-- -->
					<ul class="nav nav-pills" role="tablist">
						<!---->
						<li class="nav-item"
							[hidden]="(typeOfResidencialData && typeOfResidencialData.type &&typeOfResidencialData.type.men != true)||(typeOfResidencialData == undefined)">
							<a class="nav-link active tab-btn" data-toggle="tab" href="#m_tabs_men" #menTab>
								Residential Facility for Men
							</a>
						</li>
						<!---->
						<li class="nav-item"
							[hidden]="(typeOfResidencialData && typeOfResidencialData.type &&typeOfResidencialData.type.women != true)||(typeOfResidencialData == undefined)">
							<a class="nav-link tab-btn" data-toggle="tab" href="#m_tabs_women" #womenTab>
								Residential Facility for Women
							</a>
						</li>
						<!--*ngIf =""-->
						<!--[hidden]="typeOfResidencialData && typeOfResidencialData.type &&typeOfResidencialData.type.transgender ==false"-->
						<li class="nav-item"
							[hidden]="(typeOfResidencialData && typeOfResidencialData.type &&typeOfResidencialData.type.transgender != true)||(typeOfResidencialData == undefined)">
							<a class="nav-link tab-btn" data-toggle="tab" href="#m_tabs_transgender" #transgenderTab>
								Residential Facility for Transgender
							</a>
						</li>
					</ul>
					<hr>

						<!-- <div class="row"> -->
							<!-- <div class="col-md-2 px-1 bg-dark" style="background-color:#ef7e22;color:white"
								*ngIf="typeOfResidencialData && typeOfResidencialData.type &&typeOfResidencialData.type.men ==true">
								<div class="py-2 sticky-top flex-grow-1">
									<div (click)="scrollTo('section1')">Address Details
										<ng-container *ngIf="currentSection==='section1'">O</ng-container>
									</div>
									<div (click)="scrollTo('section2')">Amenities
										<ng-container *ngIf="currentSection==='section2'">O</ng-container>
									</div>
									<div (click)="scrollTo('section3')">Infra Details
										<ng-container *ngIf="currentSection==='section3'">O</ng-container>
									</div>
								</div>
							</form>
							<app-d-form-group [fnBuffer]="buffer" *ngIf="formDataLoaded" [(formData)]="typeOfResidencialData" (formLoaded)="onFormLoaded()" [formArray]="typeOfResidencialForm" [defaultValues]="typeOfResidentialInitialDefault" (validChange)="validity.typeOfResidencial = $event"></app-d-form-group>
						</div>
						-->

						<div class="tab-content">
							<div class="tab-pane active" id="m_tabs_men" role="cm" *ngIf="typeOfResidencialData && typeOfResidencialData.type &&typeOfResidencialData.type.men ==true">
								<form [formGroup]="residentialFormGroup">
									<ng-container formGroupName="menForm">
										<div class="col-md-10" style="padding-left: 50px; padding-top: 29px"
											*ngIf="typeOfResidencialData && typeOfResidencialData.type &&typeOfResidencialData.type.men ==true">
											<!-- <div class="form-group m-form__group row">
										<div class="col-4 sub-header">
											Type of residential Facility
										</div>
										<div class="col-8 col-lg-8 col-md-8 col-sm-8">
											<div class="kt-checkbox-list">
													<label class='m-checkbox m-checkbox--default col-6' >
														<input type="checkbox"> Male
														<span></span>
													</label>
													<label class='m-checkbox m-checkbox--default col-6' >
														<input type="checkbox">Female
														<span></span>
													</label>
													<label class='m-checkbox m-checkbox--default col-6' >
														<input type="checkbox"> Transgender
														<span></span>
													</label>
											</div>
										</div>
										</div> -->
											<!--*ngIf="typeOfResidencialData && typeOfResidencialData.typeOfResidentialFacility &&ypeOfResidencialData.typeOfResidentialFacility.male ==true"-->
											<!-- </app-d-form-group> -->
											<!-- <div class="m-form__heading margin-bottom-40">
										<h3 class="m-form__heading-title form-subhead-label-style subheader fontStyle">
											Residential Facilities for Men
										</h3>
									</div> -->
											<!-- <div id="parentDivs" scrollSpy [spiedTags]="['DIV']"
												(sectionChange)="onSectionChange($event)" > -->
												<!-- <div id="section1"> -->
													<div class="m-portlet__head" id="parentDiv">
														<div class="m-portlet__head-caption">
															<div class="m-portlet__head-title">
																<h3 class="m-portlet__head-text label-style">
																	<p>Address Details</p>
																</h3>
															</div>
														</div>
														<!--bindings={}-->
													</div>
													<!--div class="row">
														<ng-container
															*ngIf="!menCopy.transgenderAddress && typeOfResidencialData && typeOfResidencialData.type &&typeOfResidencialData.type.women ==true">
															<label class="font-texting col-4 text-align-ment">Is Address
																Same as
																Women Residential Facility</label>
															<div class="col-7">
																<label class="m-checkbox m-checkbox--default">
																	<input type="checkbox"
																		[(ngModel)]="menCopy.womenAddress"
																		[ngModelOptions]="{standalone: true}"
																		(change)="menNeedToCopyAddressOf('women',menCopy.womenAddress)"
																		[disabled]="!validity.addressForWomen"
																		value="menCopy.womenAddress" /> <span></span>
																</label>
															</div>
														</ng-container>
														<ng-container
															*ngIf="!menCopy.womenAddress && typeOfResidencialData && typeOfResidencialData.type &&typeOfResidencialData.type.transgender ==true">
															<label class="font-texting col-4 text-align-ment">Is Address
																Same as
																Transgender Residential Facility</label>
															<div class="col-7">
																<label class="m-checkbox m-checkbox--default">
																	<input type="checkbox"
																		[(ngModel)]="menCopy.transgenderAddress"
																		[ngModelOptions]="{standalone: true}"
																		(change)="menNeedToCopyAddressOf('transgender',menCopy.transgenderAddress)"
																		[disabled]="!validity.addressForTransgender"
																		value="menCopy.transgenderAddress" />
																	<span></span>
																</label>
															</div>
														</ng-container>
													</div-->
													<!--subLabel="Address of the Residential Facilities for Men"-->
													<app-address-form [(options)]="addressOptions"
														*ngIf="formDataLoaded" [completeAddress]="data.addressForMen"
														(stateChange)="stateChange($event)"
														(completeAddressChange)="data.addressForMen = $event.address"
														(validChange)="addressValidityOfMen($event)" [tccaf]=true
														addressProofRequired=true addressProofTypeRequired=true
														(control)="addressControlMen=$event"></app-address-form>
													<div class="row app-d-form-group"
														*ngIf="data && data.addressForMen && data.addressForMen.addressProof && menCopy.transgenderAddress == false && menCopy.womenAddress == false">
														<label class="col-4 text-align-ment">
														</label>
														<div class="select-div col-8">

															<app-file-download
																[fileURL]="data.addressForMen.addressProof"
																[buttonText]="downloadText">
															</app-file-download>
														</div>
													</div>
													<div class="row form-group cot-spacing">
														<label class="col-4 text-align-ment">Is the Residential facility
															within
															7 Km
															from Training Centre (TC): <span class="mandatory">*</span>
														</label>
														<div class="select-div col-8">
															<div class="form-select-side">
																<svg width="10px" height="12px" version="1.1"
																	xmlns="http://www.w3.org/2000/svg"
																	viewBox="0 0 129 129"
																	enable-background="new 0 0 129 129">
																	<g>
																		<path
																			d="m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z">
																		</path>
																	</g>
																</svg>
															</div>
															<select class="form-control m-input" id="exampleSelect1"
																formControlName="availabilityOfTransportSystem" disabled>
																<option value=null disabled>Select Is the Residential
																	facility
																	within 7 Km from Training Centre (TC)</option>
																<option [ngValue]="true">Yes</option>
																<option [ngValue]="false">No</option>
															</select> <span>If distance from TC is greater than 1.5 Km
																(upto
																7
																Km
																Max.), to
																and fro transportation facility to be provided.</span>
															<app-form-control-messages
																[control]="residentialFormGroup.get('menForm').get('availabilityOfTransportSystem')"
																[name]="'Is the Residential facility within 7 Km from Training Centre'">
															</app-form-control-messages>
														</div>
													</div>
												<!-- </div> -->
												<!-- <div id="section2"> -->
													<app-d-form-group [fnBuffer]="buffer" *ngIf="formDataLoaded"
														[(formData)]="residentialFacilities"
														(formLoaded)="onFormLoaded()"
														[formArray]="residentialFacilitiesForm"
														[defaultValues]="existingResidentialFacilitiesForMen"
														(validChange)="residentialForMen($event)"
														(control)="menControl=$event">
													</app-d-form-group>
												<!-- </div> -->
												<!-- <div id="section3"> -->
													<ng-container formArrayName="dustbinSize">
														<!-- <div class="row form-group cot-spacing">
																		<label class="col-4 text-align-ment">Availability of Display Board at front of the building  mentioning Training Centre/Hostel Name:
																					<span class="mandatory">*</span>
																				</label>
																				<div class="select-div col-8">
																						<div class="form-select-side">
																						  <svg width="10px" height="12px" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 129 129" enable-background="new 0 0 129 129">
																							<g>
																							  <path d="m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z"></path>
																							</g>
																						  </svg>

																						</div>
																			<select class="form-control m-input"
																			id="exampleSelect1" required>
																			   <option value=null disabled>Select Availability of Display Board</option>
																			   <option  [value]=true>Yes</option>
																			   <option  [value]=false>No</option>
																		   </select>

																		   </div>

																		</div>			 -->
														<ng-container
															*ngFor="let cotDetail of residentialFormGroup.get('menForm').get('dustbinSize')['controls']; let dustbinSizeIndex = index ;let lstdustbinSize=last">
															<ng-container [formGroupName]="dustbinSizeIndex"
																class="row form-group">
															</ng-container>
															<div class="row form-group">
																<label class="text-align col-4 ">Dustbin Size (in Ltr)
																	{{dustbinSizeIndex+1}}: <span
																		class="mandatory">*</span>
																</label>
																<div class="col-8 ">
																	<input type="number" disabled
																		formControlName="{{dustbinSizeIndex}}"
																		onkeypress="return (event.charCode == 8 || event.charCode == 0 ||
																		event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <=
																		57" onpaste="return false" maxlength="4" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
																		class="form-control m-input text-side-padding"
																		placeholder="Enter Dustbin size in ltrs.">
																	<!-- <span>Minimum Cot Length to be 6 ft</span> -->
																	<app-form-control-messages
																		[control]="residentialFormGroup.get('menForm').get('dustbinSize')['controls'][dustbinSizeIndex]"
																		[name]="'Dustbin Size'">
																	</app-form-control-messages>
																</div>
															</div>
														</ng-container>
													</ng-container>
													<app-d-form-group [fnBuffer]="buffer" *ngIf="formDataLoaded"
														[(formData)]="infraFormMen.formData"
														(formLoaded)="onFormLoaded()" [formArray]="infraFormMen.form"
														[defaultValues]="infraFormMen.defaultValue"
														(validChange)="infraFormMen.validity = $event"
														(control)="infraFormMen.control=$event"></app-d-form-group>
													<ng-container formArrayName="areaOfToilet">
														<ng-container
															*ngFor="let cotDetail of residentialFormGroup.get('menForm').get('areaOfToilet')['controls']; let areaOfToiletIndex = index ;let lstCotDtails=last">
															<ng-container [formGroupName]="areaOfToiletIndex"
																class="row form-group"></ng-container>
															<div class="row form-group">
																<label class="text-align col-4 ">Area of Toilet (in sq.ft)
																	{{areaOfToiletIndex+1}}: <span
																		class="mandatory">*</span>
																</label>
																<div class="col-8 ">
																	<input type="number" disabled
																		formControlName="{{areaOfToiletIndex}}"
																		onkeypress="return (event.charCode == 8 || event.charCode == 0 ||
													event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <=
													57" onpaste="return false" maxlength="4" (change)="areaOfTolietChange('men')"
																		oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
																		class="form-control m-input text-side-padding"
																		placeholder="Enter Area of Toilet in sq.ft.">
																	<!-- <span>Minimum Cot Length to be 6 ft</span> -->
																	<app-form-control-messages
																		[control]="residentialFormGroup.get('menForm').get('areaOfToilet')['controls'][areaOfToiletIndex]"
																		[name]="'Area of Toilet'">
																	</app-form-control-messages>
																</div>
															</div>
														</ng-container>
													</ng-container>
													<ng-container formArrayName="areaOfBathroom">
														<ng-container
															*ngFor="let cotDetail of residentialFormGroup.get('menForm').get('areaOfBathroom')['controls']; let areaOfBathroomIndex = index ;let lstCotDtails=last">
															<ng-container [formGroupName]="areaOfBathroomIndex"
																class="row form-group"></ng-container>
															<div class="row form-group">
																<label class="text-align col-4 ">Area of Bathroom (in sq.ft)
																	{{areaOfBathroomIndex+1}}: <span
																		class="mandatory">*</span>
																</label>
																<div class="col-8 ">
																	<input type="number" disabled
																		formControlName="{{areaOfBathroomIndex}}"
																		onkeypress="return (event.charCode == 8 || event.charCode == 0 ||
																event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <=
																57" onpaste="return false" maxlength="4" (change)="areaOfBathroomChange('men')"
																		oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
																		class="form-control m-input text-side-padding"
																		placeholder="Enter Area of Bathroom in sq.ft.">
																	<!-- <span>Minimum Cot Length to be 6 ft</span> -->
																	<app-form-control-messages
																		[control]="residentialFormGroup.get('menForm').get('areaOfBathroom')['controls'][areaOfBathroomIndex]"
																		[name]="'Area of Bathroom'">
																	</app-form-control-messages>
																</div>
															</div>
														</ng-container>
													</ng-container>
													<ng-container formArrayName="areaOfToiletCumBathroom">
														<ng-container
															*ngFor="let cotDetail of residentialFormGroup.get('menForm').get('areaOfToiletCumBathroom')['controls']; let areaOfToiletCumBathroomIndex = index ;let lstCotDtails=last">
															<ng-container [formGroupName]="areaOfToiletCumBathroomIndex"
																class="row form-group"></ng-container>
															<div class="row form-group">
																<label class="text-align col-4 ">Area of Toilet Cum (in sq.ft)
																	Bathroom
																	{{areaOfToiletCumBathroomIndex+1}}: <span
																		class="mandatory">*</span>
																</label>
																<div class="col-8 ">
																	<input type="number" disabled
																		(ngModelChange)="areaOfBathroomCumToiletChange('men')"
																		formControlName="{{areaOfToiletCumBathroomIndex}}"
																		onkeypress="return (event.charCode == 8 || event.charCode == 0 ||
																			event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <=
																			57" onpaste="return false" maxlength="4" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
																		class="form-control m-input text-side-padding"
																		placeholder="Enter Area of Toilet Cum Bathroom in sq.ft.">
																	<!-- <span>Minimum Cot Length to be 6 ft</span> -->
																	<app-form-control-messages
																		[control]="residentialFormGroup.get('menForm').get('areaOfToiletCumBathroom')['controls'][areaOfToiletCumBathroomIndex]"
																		[name]="'Area of Toilet Cum Bathroom'">
																	</app-form-control-messages>
																</div>
															</div>
														</ng-container>
													</ng-container>
													<app-d-form-group [fnBuffer]="buffer" *ngIf="formDataLoaded"
														[(formData)]="diningAreaFormsMen.formData"
														(formLoaded)="onFormLoaded()"
														[formArray]="diningAreaFormsMen.form"
														[defaultValues]="diningAreaFormsMen.defaultValue"
														(validChange)="diningAreaFormsMen.validity = $event"
														(control)="diningAreaFormsMen.control=$event">
													</app-d-form-group>
													<app-d-form-group [fnBuffer]="buffer" *ngIf="formDataLoaded"
														[(formData)]="diningAreaRecreationalFormsMen.formData"
														(formLoaded)="onFormLoaded()"
														[formArray]="diningAreaRecreationalFormsMen.form"
														[defaultValues]="diningAreaRecreationalFormsMen.defaultValue"
														(validChange)="diningAreaRecreationalFormsMen.validity = $event"
														(control)="diningAreaRecreationalFormsMen.control=$event">
													</app-d-form-group>
													<ng-container
														formArrayName="dustbinSizeInDiningAreaRecreationalArea">
														<ng-container
															*ngFor="let cotDetail of residentialFormGroup.get('menForm').get('dustbinSizeInDiningAreaRecreationalArea')['controls']; let dustbinSizeInDiningAreaRecreationalAreaIndex = index ;let lstdustbinSizeInDiningAreaRecreationalArea=last">
															<ng-container
																[formGroupName]="dustbinSizeInDiningAreaRecreationalAreaIndex"
																class="row form-group"></ng-container>
															<div class="row form-group">
																<label class="text-align col-4 ">Dustbin Size (in Ltr)
																	{{dustbinSizeInDiningAreaRecreationalAreaIndex+1}}:
																	<span class="mandatory">*</span>
																</label>
																<div class="col-8 ">
																	<input type="number" disabled
																		formControlName="{{dustbinSizeInDiningAreaRecreationalAreaIndex}}"
																		onkeypress="return (event.charCode == 8 || event.charCode == 0 ||
													event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <=
													57" onpaste="return false" maxlength="4" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
																		class="form-control m-input text-side-padding"
																		placeholder="Enter Dustbin Size in ltrs">
																	<!-- <span>Minimum Cot Length to be 6 ft</span> -->
																	<app-form-control-messages
																		[control]="residentialFormGroup.get('menForm').get('dustbinSizeInDiningAreaRecreationalArea')['controls'][dustbinSizeInDiningAreaRecreationalAreaIndex]"
																		[name]="'Dustbin Size In Dining Area + Recreational Area'">
																	</app-form-control-messages>
																</div>
															</div>
														</ng-container>
													</ng-container>
												<!-- </div> -->
											<!-- </div> -->
											<!-- <label class="m-checkbox">
										<input type="checkbox" [(ngModel)]="sameAsPermanentAddres" [disabled]="!(validity.permanentAddressValid)" (change)="copyPermanentAddress()"> Same as Permanent Address
										<span></span>
									</label> -->
											<!-- <div class="form-group m-form__group row">
												<div class="col-10"></div>
												<div class="col-2 col-lg-2 col-md-2 col-sm-12">
													<button class="btn btn-secondary" data-toggle="modal"
														*ngIf="typeOfResidencialData && typeOfResidencialData.type &&typeOfResidencialData.type.men ==true"
														data-backdrop="static" (click)="checkAddRoom('Men')"
														data-target="#addRoomForm">Add Rooms <span
															class="mandatory">*</span>
													</button>
												</div>
											</div> -->
										</div>
										<div class="form-group m-form__group table-side-space"
											*ngIf="typeOfResidencialData && typeOfResidencialData.type &&typeOfResidencialData.type.men ==true">
											<div class="m-section">
												<div class="m-section__content">
													<div class="m_datatable m-datatable m-datatable--default m-datatable--loaded"
														id="base_responsive_columns" style="position: static; zoom: 1;">
														<table class="table table-striped classroom-table">
															<thead>
																<tr>
																	<th style="min-width: 110px;">Room No.</th>
																	<th style="min-width: 110px;">Room Area</th>
																	<th style="min-width: 110px;">Capacity of Room</th>
																	<th style="min-width: 110px;">Ceiling Height</th>
																	<th style="min-width: 110px;">Availability of Doors
																		in
																		room</th>
																	<th style="min-width: 110px;">Availability of
																		windows in
																		room</th>
																	<th style="min-width: 50px!important;">Area Equipped
																		With</th>
																	<!-- <th style="min-width: 30px!important;">Delete Room
																	</th> -->
																	<th style="min-width: 30px!important;">View</th>
																</tr>
															</thead>
															<tbody>
																<tr *ngFor="let room of menRooms;let i = index">
																	<td style="min-width: 110px;">Room_{{i+1}}</td>
																	<td style="min-width: 110px;">{{room.roomArea}}</td>
																	<td style="min-width: 110px;">{{room.capacity}}</td>
																	<td style="min-width: 110px;">{{room.ceilingHeight}}
																	</td>
																	<td style="min-width: 110px;">
																		{{room.availabilityOfDoorAtEntrance==true?'Yes':'No'}}
																	</td>
																	<td style="min-width: 110px;">
																		{{room.availabilityOfWindowCrossVentilation==true?'Yes':'No'}}
																	</td>
																	<td style="min-width: 50px!important;">
																		{{ room?.areaEquippedWith?.cot ? 'Cot' + ',' : '' }}
																		{{ room?.areaEquippedWith?.matress ? 'Mattress'+ ',' : '' }}
																		{{ room?.areaEquippedWith?.pillow ? 'Pillow'+ ',' : '' }}
																		{{ room?.areaEquippedWith?.trunkWithLock ? 'Trunk with lock'+ ',' : '' }}
																		{{ room?.areaEquippedWith?.cupboardLockingArrangement ? 'Cupboard/Almirah with locking Arrangement'+ ',' : '' }}
																		{{ room?.areaEquippedWith?.ledCFLIncandentLight ? 'LED/CFL/Incandescent light bulb(1000-1400 lumens)'+ ',' : '' }}
																		{{ room?.areaEquippedWith?.ceilingFan ? 'Ceiling Fan'+ ',' : '' }}
																		{{ room?.areaEquippedWith?.plugPoint ? 'Plug Point'+ ',' : '' }}
																		{{ room?.areaEquippedWith?.availabilityOfDedicatedHousekeepingStaff ? 'Availability of dedicated housekeeping staff at the Residential Facility'+ ',' : '' }}
																		{{ room?.areaEquippedWith?.availabilityOfSafeDrinkingWater ? 'Availability of safe/clean drinking water facility in the form of Reverse Osmosis(RO)/Water purifier/Packaged drinking water/Packaged drinking' : '' }}
																		{{ room?.areaEquippedWith?.powerBackUp ? 'Availability of power backup covering basic facilities such as lights and Fans'+ ',' : '' }}
																	</td>
																	<!-- <td style="min-width: 30px!important;">
																		<a> <i class="la la-trash delete-icon"
																				title="remove"
																				(click)="removeRooom(i,'Men')"></i>
																		</a>
																	</td> -->
																	<td style="min-width: 30px!important;">
																		<a data-backdrop="static"
																			data-target="#addRoomForm"
																			data-toggle="modal"> <i
																				class="la la-edit edit-icon"
																				title="edit"
																				(click)="checkAddRoom('Men');editRooom(i,'Men')"></i>
																		</a>
																	</td>
																</tr>
															</tbody>
															<ng-template #labDataElse>
																<ng-container>
																	<tbody class="text-center">
																		<tr class="text-center">No record found</tr>
																	</tbody>
																</ng-container>
															</ng-template>
														</table>
													</div>
												</div>
											</div>
										</div>
										<div class="col-md-10" style="padding-left: 50px; padding-top: 29px"
											*ngIf="typeOfResidencialData && typeOfResidencialData.type &&typeOfResidencialData.type.men ==true">
											<div class="row form-group cot-spacing">
												<label class="text-align col-4">Total Area for Male Residential Facility:

													<!-- <span class="mandatory">*</span> -->
												</label>
												<div class="col-8">
													<input type="number" disabled formControlName="totalArea"
														(change)="calculationForTotalArea()" readOnly
														class="form-control m-input text-side-padding"> <span>Total Area
														auto calculated</span>
													<!-- <span>Minimum Cot Length to be 6 ft</span> -->
												</div>
											</div>
											<div class="row form-group cot-spacing">
												<label class="text-align col-4">
													Total Capacity for Male Residential Facility:
													<!-- <span class="mandatory">*</span> -->
												</label>
												<div class="col-8">
													<input type="number" readOnly formControlName="capacity"
														(change)="calculationForTotalCapacity()"
														class="form-control m-input text-side-padding"> <span>Total
														Capacity
														auto calculated</span>
													<!-- <span>Minimum Cot Length to be 6 ft</span> -->
												</div>
											</div>
										</div>
									</ng-container>
								</form>
								<hr>
								<div class=" m-portlet__body row save-next">
									<!--[disabled]="!validForMen"-->
									<!-- <div class="col-lg-5 col-md-5 col-sm-12" *ngIf="typeOfResidencialData && typeOfResidencialData.type &&typeOfResidencialData.type.women ==false&&typeOfResidencialData.type.transgender ==false">
									<button class="btn btn-info" (click)="SaveAndNext()">Save & Next</button>
								</div> -->
									<!--<button class="btn btn-secondary" (click)="saveAsDraft()">Save As Draft</button>-->
									<!-- [disabled]="getMenValidity()" -->
									<div class="col-lg-5 col-md-5 col-sm-12 text-align"
										*ngIf="typeOfResidencialData && typeOfResidencialData.type && typeOfResidencialData.type.men ==true">
										<button class="btn btn-info"
											(click)="saveAndNext('men')">Next</button>
										<!--[disabled]="!validForMen"-->
										<!--<button class="btn btn-secondary" (click)="saveAsDraft()">Save As Draft</button>-->
									</div>
								</div>
							</div>
						<!-- </div> -->
						<div class="tab-pane" id="m_tabs_women" role="cm"
							[hidden]="typeOfResidencialData && typeOfResidencialData.type &&typeOfResidencialData.type.women ==false">
							<form [formGroup]="residentialFormGroup">
								<ng-container formGroupName="womenForm">
									<div class="col-md-10" style="padding-left: 50px; padding-top: 29px"
										[hidden]="typeOfResidencialData && typeOfResidencialData.type &&typeOfResidencialData.type.women ==false">
										<div class="row">
											<ng-container
												*ngIf="!womenCopy.transgenderAddress && typeOfResidencialData && typeOfResidencialData.type &&typeOfResidencialData.type.men ==true">
												<label class="font-texting col-4 text-align-ment">Is Address Same as Men
													Residential Facility</label>
												<div class="col-7">
													<label class="m-checkbox m-checkbox--default">
														<input type="checkbox" [(ngModel)]="womenCopy.menAddress"
															[ngModelOptions]="{standalone: true}"
															(change)="womenNeedToCopyAddressOf('men',womenCopy.menAddress)"
															[disabled]="!validity.addressForMen"
															value="womenCopy.menAddress"
															(change)="copyAddresFromMen()" /> <span></span>
													</label>
												</div>
											</ng-container>
											<ng-container
												*ngIf="!womenCopy.menAddress && typeOfResidencialData && typeOfResidencialData.type &&typeOfResidencialData.type.transgender ==true">
												<label class="font-texting col-4 text-align-ment">Is Address Same as
													Transgender Residential Facility</label>
												<div class="col-7">
													<label class="m-checkbox m-checkbox--default">
														<input type="checkbox"
															[(ngModel)]="womenCopy.transgenderAddress"
															[ngModelOptions]="{standalone: true}"
															(change)="womenNeedToCopyAddressOf('transgender',womenCopy.transgenderAddress)"
															[disabled]="!validity.addressForTransgender"
															value="womenCopy.transgenderAddress" /> <span></span>
													</label>
												</div>
											</ng-container>
										</div>
										<!--subLabel="Address of the Residential Facilities for Women"-->
										<app-address-form [(options)]="addressOptions" [residential]=true
											*ngIf="formDataLoaded" [completeAddress]="data.addressForWomen"
											(stateChange)="stateChange($event)"

											(completeAddressChange)="data.addressForWomen = $event.address"
											(validChange)="addressValidityOfWomen($event)" [tccaf]=true
											addressProofRequired=true addressProofTypeRequired=true
											(control)="addressControlWoMen=$event"></app-address-form>
										<div class="row app-d-form-group"
											*ngIf="data && data.addressForWomen && data.addressForWomen.addressProof && womenCopy.menAddress == false && womenCopy.transgenderAddress == false">
											<label class="col-4 text-align-ment">
											</label>
											<div class="select-div col-8">


												<app-file-download [fileURL]="data.addressForWomen.addressProof"
													[buttonText]="downloadText">
												</app-file-download>
											</div>
										</div>
										<div class="row form-group cot-spacing"
											*ngIf="typeOfResidencialData && typeOfResidencialData.type &&typeOfResidencialData.type.men ==true">
											<label class="col-4 text-align-ment">Separate entrances for Male and Female
												Facility if the hostel is in the same building: <span
													class="mandatory">*</span>
											</label>
											<div class="select-div col-8">
												<div class="form-select-side">
													<svg width="10px" height="12px" version="1.1"
														xmlns="http://www.w3.org/2000/svg" viewBox="0 0 129 129"
														enable-background="new 0 0 129 129">
														<g>
															<path
																d="m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z">
															</path>
														</g>
													</svg>
												</div>
												<select class="form-control m-input" id="exampleSelect1"
													formControlName="seperateEntranceForMF" required>
													<option value=null disabled>Select Separate entrances for Male and
														Female Facility if the hostel is in the same building</option>
													<option [value]=true>Yes</option>
													<option [value]=false>No</option>
												</select> <span>Male & Female Facilities can be on different floors of
													the same
													building but with dedicated entries.</span>
												<app-form-control-messages
													[control]="residentialFormGroup.get('womenForm').get('seperateEntranceForMF')"
													[name]="'Separate entrances for Male and Female Facility if the hostel is in the same building'">
												</app-form-control-messages>
											</div>
										</div>
										<div class="row form-group cot-spacing">
											<label class="col-4 text-align-ment">Is the Residential facility within 7 Km
												from Training Centre (TC): <span class="mandatory">*</span>
											</label>
											<div class="select-div col-8">
												<div class="form-select-side">
													<svg width="10px" height="12px" version="1.1"
														xmlns="http://www.w3.org/2000/svg" viewBox="0 0 129 129"
														enable-background="new 0 0 129 129">
														<g>
															<path
																d="m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z">
															</path>
														</g>
													</svg>
												</div>
												<select class="form-control m-input" id="exampleSelect1"
													formControlName="availabilityOfTransportSystem" disabled>
													<option value=null disabled>Select Is the Residential facility
														within 7 Km from Training Centre (TC)</option>
													<option [ngValue]="true">Yes</option>
													<option [ngValue]="false">No</option>
												</select> <span>If distance from TC is greater than 1.5 Km (upto 7 Km
													Max.), to
													and fro transportation facility to be provided.</span>
												<app-form-control-messages
													[control]="residentialFormGroup.get('womenForm').get('availabilityOfTransportSystem')"
													[name]="'Is the Residential facility within 7 Km from Training Centre'">
												</app-form-control-messages>
											</div>
										</div>
										<app-d-form-group [fnBuffer]="buffer" *ngIf="formDataLoaded"
											[(formData)]="residentialFacilitiesWomen" (formLoaded)="onFormLoaded()"
											[formArray]="womenForm"
											[defaultValues]="existingResidentialFacilitiesForWomen"
											(validChange)="residentialForWoMen($event)" (control)="womenControl=$event">
										</app-d-form-group>
										<ng-container formArrayName="dustbinSize">
											<ng-container
												*ngFor="let cotDetail of residentialFormGroup.get('womenForm').get('dustbinSize')['controls']; let dustbinSizeIndex = index ;let lstdustbinSize=last">
												<ng-container [formGroupName]="dustbinSizeIndex" class="row form-group">
												</ng-container>
												<div class="row form-group">
													<label class="text-align col-4 ">Dustbin Size (in Ltr)
														{{dustbinSizeIndex+1}}: <span class="mandatory">*</span>
													</label>
													<div class="col-8 ">
														<input type="number" disabled formControlName="{{dustbinSizeIndex}}"
															onkeypress="return (event.charCode == 8 || event.charCode == 0 ||
																	event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <=
																	57" onpaste="return false" maxlength="4" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
															class="form-control m-input text-side-padding"
															placeholder="Enter Dustbin Size in ltrs.">
														<!-- <span>Minimum Cot Length to be 6 ft</span> -->
														<app-form-control-messages
															[control]="residentialFormGroup.get('womenForm').get('dustbinSize')['controls'][dustbinSizeIndex]"
															[name]="'Dustbin Size'"></app-form-control-messages>
													</div>
												</div>
											</ng-container>
										</ng-container>
										<app-d-form-group [fnBuffer]="buffer" *ngIf="formDataLoaded"
											[(formData)]="infraFormWomen.formData" (formLoaded)="onFormLoaded()"
											[formArray]="infraFormWomen.form"
											[defaultValues]="infraFormWomen.defaultValue"
											(validChange)="infraFormWomen.validity = $event"
											(control)="infraFormWomen.control=$event"></app-d-form-group>
										<ng-container formArrayName="areaOfToilet">
											<ng-container
												*ngFor="let cotDetail of residentialFormGroup.get('womenForm').get('areaOfToilet')['controls']; let areaOfToiletIndex = index ;let lstCotDtails=last">
												<ng-container [formGroupName]="areaOfToiletIndex"
													class="row form-group"></ng-container>
												<div class="row form-group">
													<label class="text-align col-4 ">Area of Toilet (in sq.ft)
														{{areaOfToiletIndex+1}}: <span class="mandatory">*</span>
													</label>
													<div class="col-8 ">
														<input type="number" disabled (change)="areaOfTolietChange('women')"
															formControlName="{{areaOfToiletIndex}}" onkeypress="return (event.charCode == 8 || event.charCode == 0 ||
																	event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <=
																	57" onpaste="return false" maxlength="4" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
															class="form-control m-input text-side-padding"
															placeholder="Enter Area of Toilet in sq.ft.">
														<!-- <span>Minimum Cot Length to be 6 ft</span> -->
														<app-form-control-messages
															[control]="residentialFormGroup.get('womenForm').get('areaOfToilet')['controls'][areaOfToiletIndex]"
															[name]="'Area of Toilet'"></app-form-control-messages>
													</div>
												</div>
											</ng-container>
										</ng-container>
										<ng-container formArrayName="areaOfBathroom">
											<ng-container
												*ngFor="let cotDetail of residentialFormGroup.get('womenForm').get('areaOfBathroom')['controls']; let areaOfBathroomIndex = index ;let lstCotDtails=last">
												<ng-container [formGroupName]="areaOfBathroomIndex"
													class="row form-group"></ng-container>
												<div class="row form-group">
													<label class="text-align col-4 ">Area of Bathroom (in sq.ft)
														{{areaOfBathroomIndex+1}}: <span class="mandatory">*</span>
													</label>
													<div class="col-8 ">
														<input type="number" disabled (change)="areaOfBathroomChange('women')"
															formControlName="{{areaOfBathroomIndex}}" onkeypress="return (event.charCode == 8 || event.charCode == 0 ||
																				event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <=
																				57" onpaste="return false" maxlength="4"
															oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
															class="form-control m-input text-side-padding"
															placeholder="Enter Area of Bathroom in sq.ft.">
														<!-- <span>Minimum Cot Length to be 6 ft</span> -->
														<app-form-control-messages
															[control]="residentialFormGroup.get('womenForm').get('areaOfBathroom')['controls'][areaOfBathroomIndex]"
															[name]="'Area of Bathroom'"></app-form-control-messages>
													</div>
												</div>
											</ng-container>
										</ng-container>
										<ng-container formArrayName="areaOfToiletCumBathroom">
											<ng-container
												*ngFor="let cotDetail of residentialFormGroup.get('womenForm').get('areaOfToiletCumBathroom')['controls']; let areaOfToiletCumBathroomIndex = index ;let lstCotDtails=last">
												<ng-container [formGroupName]="areaOfToiletCumBathroomIndex"
													class="row form-group"></ng-container>
												<div class="row form-group">
													<label class="text-align col-4 ">Area of Toilet Cum Bathroom (in sq.ft)
														{{areaOfToiletCumBathroomIndex+1}}: <span
															class="mandatory">*</span>
													</label>
													<div class="col-8 ">
														<input type="number" disabled
															(change)="areaOfBathroomCumToiletChange('women')"
															formControlName="{{areaOfToiletCumBathroomIndex}}"
															onkeypress="return (event.charCode == 8 || event.charCode == 0 ||
																							event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <=
																							57" onpaste="return false" maxlength="4"
															oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
															class="form-control m-input text-side-padding"
															placeholder="Enter Area of Toilet Cum Bathroom in sq.ft.">
														<!-- <span>Minimum Cot Length to be 6 ft</span> -->
														<app-form-control-messages
															[control]="residentialFormGroup.get('womenForm').get('areaOfToiletCumBathroom')['controls'][areaOfToiletCumBathroomIndex]"
															[name]="'Area of Toilet Cum Bathroom'">
														</app-form-control-messages>
													</div>
												</div>
											</ng-container>
										</ng-container>
										<app-d-form-group [fnBuffer]="buffer" *ngIf="formDataLoaded"
											[(formData)]="diningAreaFormsWomen.formData" (formLoaded)="onFormLoaded()"
											[formArray]="diningAreaFormsWomen.form"
											[defaultValues]="diningAreaFormsWomen.defaultValue"
											(validChange)="diningAreaFormsWomen.validity = $event"
											(control)="diningAreaFormsWomen.control=$event"></app-d-form-group>
										<app-d-form-group [fnBuffer]="buffer" *ngIf="formDataLoaded"
											[(formData)]="diningAreaRecreationalFormsWomen.formData"
											(formLoaded)="onFormLoaded()"
											[formArray]="diningAreaRecreationalFormsWomen.form"
											[defaultValues]="diningAreaRecreationalFormsWomen.defaultValue"
											(validChange)="diningAreaRecreationalFormsWomen.validity = $event"
											(control)="diningAreaRecreationalFormsWomen.control=$event">
										</app-d-form-group>
										<ng-container formArrayName="dustbinSizeInDiningAreaRecreationalArea">
											<ng-container
												*ngFor="let cotDetail of residentialFormGroup.get('womenForm').get('dustbinSizeInDiningAreaRecreationalArea')['controls']; let dustbinSizeInDiningAreaRecreationalAreaIndex = index ;let lstdustbinSize=last">
												<ng-container
													[formGroupName]="dustbinSizeInDiningAreaRecreationalAreaIndex"
													class="row form-group"></ng-container>
												<div class="row form-group">
													<label class="text-align col-4 ">Dustbin Size (in Ltr)
														{{dustbinSizeInDiningAreaRecreationalAreaIndex+1}}: <span
															class="mandatory">*</span>
													</label>
													<div class="col-8 ">
														<input type="number" disabled
															formControlName="{{dustbinSizeInDiningAreaRecreationalAreaIndex}}"
															onkeypress="return (event.charCode == 8 || event.charCode == 0 ||
																			event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <=
																			57" onpaste="return false" maxlength="4" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
															class="form-control m-input text-side-padding"
															placeholder="Enter Dustbin Size in ltrs.">
														<!-- <span>Minimum Cot Length to be 6 ft</span> -->
														<app-form-control-messages
															[control]="residentialFormGroup.get('womenForm').get('dustbinSizeInDiningAreaRecreationalArea')['controls'][dustbinSizeInDiningAreaRecreationalAreaIndex]"
															[name]="'Dustbin Size In Dining Area + RecreationalArea'">
														</app-form-control-messages>
													</div>
												</div>
											</ng-container>
										</ng-container>
										<!-- <label class="m-checkbox">
												<input type="checkbox" [(ngModel)]="sameAsPermanentAddres" [disabled]="!(validity.permanentAddressValid)" (change)="copyPermanentAddress()"> Same as Permanent Address
												<span></span>
											</label> -->


										<div class="form-group m-form__group row">
											<div class="col-10"></div>
											<div class="col-2 col-lg-2 col-md-2 col-sm-12">
												<!-- <button class="btn btn-secondary" data-toggle="modal"
													*ngIf="typeOfResidencialData && typeOfResidencialData.type &&typeOfResidencialData.type.women ==true"
													data-backdrop="static" (click)="checkAddRoom('Women')"
													data-target="#addRoomForm">Add Rooms <span
														class="mandatory">*</span>
												</button> -->
											</div>
										</div>
									</div>
									<div class="form-group m-form__group table-side-space"
										[hidden]="typeOfResidencialData && typeOfResidencialData.type &&typeOfResidencialData.type.women ==false">
										<div class="m-section">
											<div class="m-section__content">
												<div class="m_datatable m-datatable m-datatable--default m-datatable--loaded"
													id="base_responsive_columns" style="position: static; zoom: 1;">
													<table class="table table-striped classroom-table">
														<thead>
															<tr>
																<th style="min-width: 110px;">Room No.</th>
																<th style="min-width: 110px;">Room Area</th>
																<th style="min-width: 110px;">Capacity of Room</th>
																<th style="min-width: 110px;">Ceiling Height</th>
																<th style="min-width: 110px;">Availability of Doors in
																	room</th>
																<th style="min-width: 110px;">Availability of windows in
																	room</th>
																<th style="min-width: 50px!important;">Area Equipped
																	With</th>
																<!-- <th style="min-width: 30px!important;">Delete Room</th> -->
																<th style="min-width: 30px!important;">View</th>
															</tr>
														</thead>
														<tbody>
															<tr *ngFor="let room of womenRooms;let i = index">
																<td style="min-width: 110px;">Room_{{i+1}}</td>
																<td style="min-width: 110px;">{{room.roomArea}}</td>
																<td style="min-width: 110px;">{{room.capacity}}</td>
																<td style="min-width: 110px;">{{room.ceilingHeight}}
																</td>
																<td style="min-width: 110px;">
																	{{room.availabilityOfDoorAtEntrance==true?'Yes':'No'}}
																</td>
																<td style="min-width: 50px!important;">
																	{{room.availabilityOfWindowCrossVentilation==true?'Yes':'No'}}
																</td>
																<td style="min-width: 30px!important;">
																	{{ room?.areaEquippedWith?.cot ? 'Cot' + ',' : '' }}
																	{{ room?.areaEquippedWith?.matress ? 'Mattress'+ ',' : '' }}
																	{{ room?.areaEquippedWith?.pillow ? 'Pillow'+ ',' : '' }}
																	{{ room?.areaEquippedWith?.trunkWithLock ? 'Trunk with lock'+ ',' : '' }}
																	{{ room?.areaEquippedWith?.cupboardLockingArrangement ? 'Cupboard/Almirah with locking Arrangement'+ ',' : '' }}
																	{{ room?.areaEquippedWith?.ledCFLIncandentLight ? 'LED/CFL/Incandescent light bulb(1000-1400 lumens)'+ ',' : '' }}
																	{{ room?.areaEquippedWith?.ceilingFan ? 'Ceiling Fan'+ ',' : '' }}
																	{{ room?.areaEquippedWith?.plugPoint ? 'Plug Point'+ ',' : '' }}
																	{{ room?.areaEquippedWith?.availabilityOfDedicatedHousekeepingStaff ? 'Availability of dedicated housekeeping staff at the Residential Facility'+ ',' : '' }}
																	{{ room?.areaEquippedWith?.availabilityOfSafeDrinkingWater ? 'Availability of safe/clean drinking water facility in the form of Reverse Osmosis(RO)/Water purifier/Packaged drinking water/Packaged drinking' : '' }}
																	{{ room?.areaEquippedWith?.powerBackUp ? 'Availability of power backup covering basic facilities such as lights and Fans'+ ',' : '' }}
																</td>
																<!-- <td>
																	<a> <i class="la la-trash delete-icon"
																			title="remove"
																			(click)="removeRooom(i,'Women')"></i>
																	</a>
																</td> -->
																<td style="min-width: 30px!important;">
																	<a data-backdrop="static" data-target="#addRoomForm"
																		data-toggle="modal"> <i
																			class="la la-edit edit-icon" title="edit"
																			(click)="checkAddRoom('Women');editRooom(i,'Women')"></i>
																	</a>
																</td>
															</tr>
														</tbody>
														<ng-template #labDataElse>
															<ng-container>
																<tbody class="text-center">
																	<tr class="text-center">No record found</tr>
																</tbody>
															</ng-container>
														</ng-template>
													</table>
												</div>
											</div>
										</div>
									</div>
									<div class="col-md-10" style="padding-left: 50px; padding-top: 29px"
										*ngIf="typeOfResidencialData && typeOfResidencialData.type &&typeOfResidencialData.type.women ==true">
										<div class="row form-group cot-spacing">
											<label class="text-align col-4">Total Area for Women Residential Facility:
												<!-- <span class="mandatory">*</span> -->
											</label>
											<div class="col-8">
												<input type="number" formControlName="totalArea"
													class="form-control m-input text-side-padding" disabled> <span>Total
													Area auto calculated</span>
												<!-- <span>Minimum Cot Length to be 6 ft</span> -->
											</div>
										</div>
										<div class="row form-group cot-spacing">
											<label class="text-align col-4">Total Capacity for Women Residential
												Facility:
												<!-- <span class="mandatory">*</span> -->
											</label>
											<div class="col-8">
												<input type="number" formControlName="capacity"
													class="form-control m-input text-side-padding" disabled> <span>Total
													Capacity auto calculated</span>
												<!-- <span>Minimum Cot Length to be 6 ft</span> -->
											</div>
										</div>
									</div>
								</ng-container>
							</form>
							<hr>
							<div class=" m-portlet__body row save-next">
								<!--[disabled]="!validForWomen" -->
								<!-- <div class="col-lg-5 col-md-5 col-sm-12" *ngIf="typeOfResidencialData && typeOfResidencialData.type &&typeOfResidencialData.type.transgender ==false">
									<button class="btn btn-info" (click)="SaveAndNext()">Save & Next</button>
								</div> [disabled]="getWoMenValidity()"-->
								<!--<button class="btn btn-secondary" (click)="saveAsDraft()">Save As Draft</button>-->
								<div class="col-lg-5 col-md-5 col-sm-12 text-align"
									*ngIf="typeOfResidencialData && typeOfResidencialData.type && (typeOfResidencialData.type.women ==true)">
									<button class="btn btn-info"
										(click)="saveAndNext('women')">Next</button>
									<!--<button class="btn btn-secondary" (click)="saveAsDraft()">Save As Draft</button>-->
								</div>
								<div class="col-lg-5 col-md-5 col-sm-12"
									*ngIf="typeOfResidencialData && typeOfResidencialData.type && (typeOfResidencialData.type.women ==true)">
									<!-- <button class="btn btn-info" (click)="saveAndNext('women','saveAsDraft')">Save as
										Draft</button> -->
									<!--<button class="btn btn-secondary" (click)="saveAsDraft()">Save As Draft</button>-->
								</div>
							</div>
						</div>
						<div class="tab-pane" id="m_tabs_transgender" role="cm"
							[hidden]="typeOfResidencialData && typeOfResidencialData.type &&typeOfResidencialData.type.transgender ==false">
							<form [formGroup]="residentialFormGroup">
								<ng-container formGroupName="transgenderForm">
									<div class="col-md-10" style="padding-left: 50px; padding-top: 29px"
										[hidden]="typeOfResidencialData && typeOfResidencialData.type &&typeOfResidencialData.type.transgender ==false">
										<div class="row">
											<ng-container
												*ngIf="!transgenderCopy.womenAddress && typeOfResidencialData && typeOfResidencialData.type &&typeOfResidencialData.type.men ==true">
												<label class="font-texting col-4 text-align-ment">Is Address Same as Men
													Residential Facility</label>
												<div class="col-7">
													<label class="m-checkbox m-checkbox--default">
														<input type="checkbox" [(ngModel)]="transgenderCopy.menAddress"
															[ngModelOptions]="{standalone: true}"
															(change)="transgenderNeedToCopyAddressOf('men',transgenderCopy.menAddress)"
															[disabled]="!validity.addressForMen" /> <span></span>
													</label>
												</div>
											</ng-container>
											<ng-container
												*ngIf="!transgenderCopy.menAddress && typeOfResidencialData && typeOfResidencialData.type &&typeOfResidencialData.type.women ==true">
												<label class="font-texting col-4 text-align-ment">Is Address Same as
													Women Residential Facility</label>
												<div class="col-7">
													<label class="m-checkbox m-checkbox--default">
														<input type="checkbox"
															[(ngModel)]="transgenderCopy.womenAddress"
															[ngModelOptions]="{standalone: true}"
															(change)="transgenderNeedToCopyAddressOf('women',transgenderCopy.womenAddress)"
															[disabled]="!validity.addressForWomen" /> <span></span>
													</label>
												</div>
											</ng-container>
										</div>
										<app-address-form [(options)]="addressOptions" [residential]=true
											*ngIf="formDataLoaded" [completeAddress]="data.addressForTransgender"
											(stateChange)="stateChange($event)"
											(completeAddressChange)="data.addressForTransgender = $event.address"
											(validChange)="addressValidityOfTransgender($event)" [tccaf]=true
											addressProofRequired=true addressProofTypeRequired=true
											(control)="addressControlTransgender=$event"></app-address-form>
										<div class="row app-d-form-group"
											*ngIf="data && data.addressForTransgender && data.addressForTransgender.addressProof && transgenderCopy.menAddress == false && transgenderCopy.womenAddress == false">
											<label class="col-4 text-align-ment">
											</label>
											<div class="select-div col-8">


												<app-file-download [fileURL]="data.addressForTransgender.addressProof"
													[buttonText]="downloadText">
												</app-file-download>
											</div>
										</div>
										<div class="row form-group cot-spacing"
											*ngIf="typeOfResidencialData && typeOfResidencialData.type &&(typeOfResidencialData.type.men ==true ||typeOfResidencialData.type.women == true)">
											<label class="col-4 text-align-ment">Separate entrances for <span
													*ngIf="typeOfResidencialData.type.men == true">Male and</span> <span
													*ngIf="typeOfResidencialData.type.women == true">Women and</span>
												transgender Facility if the hostel is in the same building: <span
													class="mandatory">*</span>
											</label>
											<div class="select-div col-8">
												<div class="form-select-side">
													<svg width="10px" height="12px" version="1.1"
														xmlns="http://www.w3.org/2000/svg" viewBox="0 0 129 129"
														enable-background="new 0 0 129 129">
														<g>
															<path
																d="m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z">
															</path>
														</g>
													</svg>
												</div>
												<select class="form-control m-input" id="exampleSelect1"
													formControlName="seperateEntranceForMF" disabled>
													<option value=null disabled>Select Separate entrances for <span
															*ngIf="typeOfResidencialData.type.men == true">Male and
														</span> <span
															*ngIf="typeOfResidencialData.type.women == true">Female and
														</span>transgender Facility if the hostel is in the same
														building</option>
													<option [value]=true>Yes</option>
													<option [value]=false>No</option>
												</select> <span> <span
														*ngIf="typeOfResidencialData.type.men == true">Male
														&</span> <span
														*ngIf="typeOfResidencialData.type.women == true">Female &</span>
													Transgender Facilities can be on different floors of the same
													building but with dedicated entries.</span>
												<app-form-control-messages
													[control]="residentialFormGroup.get('transgenderForm').get('seperateEntranceForMF')"
													[name]="'Separate entrances for Male and Transgender Facility if the hostel is in the same building'">
												</app-form-control-messages>
											</div>
										</div>
										<div class="row form-group cot-spacing">
											<label class="col-4 text-align-ment">Is the Residential facility within 7 Km
												from Training Centre (TC): <span class="mandatory">*</span>
											</label>
											<div class="select-div col-8">
												<div class="form-select-side">
													<svg width="10px" height="12px" version="1.1"
														xmlns="http://www.w3.org/2000/svg" viewBox="0 0 129 129"
														enable-background="new 0 0 129 129">
														<g>
															<path
																d="m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z">
															</path>
														</g>
													</svg>
												</div>
												<select class="form-control m-input" id="exampleSelect1"
													formControlName="availabilityOfTransportSystem" disabled>
													<option value=null disabled>Select Is the Residential facility
														within 7 Km from Training Centre (TC)</option>
													<option [ngValue]="true">Yes</option>
													<option [ngValue]="false">No</option>
												</select> <span>If distance from TC is greater than 1.5 Km (upto 7 Km
													Max.), to
													and fro transportation facility to be provided.</span>
												<app-form-control-messages
													[control]="residentialFormGroup.get('transgenderForm').get('availabilityOfTransportSystem')"
													[name]="'Is the Residential facility within 7 Km from Training Centre'">
												</app-form-control-messages>
											</div>
										</div>
										<app-d-form-group *ngIf="formDataLoaded"
											[(formData)]="residentialFacilitiesTransgender"
											(formLoaded)="onFormLoaded()" [formArray]="transgenderForm"
											[defaultValues]="existingResidentialFacilitiesForTransgender"
											(validChange)="residentialForTransgender($event)"
											(control)="transgenderControl=$event" [fnBuffer]="buffer">
										</app-d-form-group>
										<ng-container formArrayName="dustbinSize">
											<ng-container
												*ngFor="let cotDetail of residentialFormGroup.get('transgenderForm').get('dustbinSize')['controls']; let dustbinSizeIndex = index ;let lstdustbinSize=last">
												<ng-container [formGroupName]="dustbinSizeIndex" class="row form-group">
												</ng-container>
												<div class="row form-group">
													<label class="text-align col-4 ">Dustbin Size (in Ltr)
														{{dustbinSizeIndex+1}}: <span class="mandatory">*</span>
													</label>
													<div class="col-8 ">
														<input type="number"disabled formControlName="{{dustbinSizeIndex}}"
															onkeypress="return (event.charCode == 8 || event.charCode == 0 ||
																			event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <=
																			57" onpaste="return false" maxlength="4" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
															class="form-control m-input text-side-padding"
															placeholder="Enter Dustbin Size in ltrs.">
														<!-- <span>Minimum Cot Length to be 6 ft</span> -->
														<app-form-control-messages
															[control]="residentialFormGroup.get('transgenderForm').get('dustbinSize')['controls'][dustbinSizeIndex]"
															[name]="'Dustbin Size'"></app-form-control-messages>
													</div>
												</div>
											</ng-container>
										</ng-container>
										<app-d-form-group [fnBuffer]="buffer" *ngIf="formDataLoaded"
											[(formData)]="infraFormTransgender.formData" (formLoaded)="onFormLoaded()"
											[formArray]="infraFormTransgender.form"
											[defaultValues]="infraFormTransgender.defaultValue"
											(validChange)="infraFormTransgender.validity = $event"
											(control)="infraFormTransgender.control=$event"></app-d-form-group>
										<ng-container formArrayName="areaOfToilet">
											<ng-container
												*ngFor="let cotDetail of residentialFormGroup.get('transgenderForm').get('areaOfToilet')['controls']; let areaOfToiletIndex = index ;let lstCotDtails=last">
												<ng-container [formGroupName]="areaOfToiletIndex"
													class="row form-group"></ng-container>
												<div class="row form-group">
													<label class="text-align col-4 ">Area of Toilet (in sq.ft)
														{{areaOfToiletIndex+1}}: <span class="mandatory">*</span>
													</label>
													<div class="col-8 ">
														<input type="number" disabled
															(change)="areaOfTolietChange('transgender')"
															formControlName="{{areaOfToiletIndex}}" onkeypress="return (event.charCode == 8 || event.charCode == 0 ||
																			event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <=
																			57" onpaste="return false" maxlength="4" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
															class="form-control m-input text-side-padding"
															placeholder="Enter Area of Toilet in sq.ft.">
														<!-- <span>Minimum Cot Length to be 6 ft</span> -->
														<app-form-control-messages
															[control]="residentialFormGroup.get('transgenderForm').get('areaOfToilet')['controls'][areaOfToiletIndex]"
															[name]="'Area of Toilet'"></app-form-control-messages>
													</div>
												</div>
											</ng-container>
										</ng-container>
										<ng-container formArrayName="areaOfBathroom">
											<ng-container
												*ngFor="let cotDetail of residentialFormGroup.get('transgenderForm').get('areaOfBathroom')['controls']; let areaOfBathroomIndex = index ;let lstCotDtails=last">
												<ng-container [formGroupName]="areaOfBathroomIndex"
													class="row form-group"></ng-container>
												<div class="row form-group">
													<label class="text-align col-4 ">Area of Bathroom (in sq.ft)
														{{areaOfBathroomIndex+1}}: <span class="mandatory">*</span>
													</label>
													<div class="col-8 ">
														<input type="number"
															(change)="areaOfBathroomChange('transgender')" disabled
															formControlName="{{areaOfBathroomIndex}}" onkeypress="return (event.charCode == 8 || event.charCode == 0 ||
																						event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <=
																						57" onpaste="return false" maxlength="4"
															oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
															class="form-control m-input text-side-padding"
															placeholder="Enter Area of Bathroom in sq.ft.">
														<!-- <span>Minimum Cot Length to be 6 ft</span> -->
														<app-form-control-messages
															[control]="residentialFormGroup.get('transgenderForm').get('areaOfBathroom')['controls'][areaOfBathroomIndex]"
															[name]="'Area of Bathroom'"></app-form-control-messages>
													</div>
												</div>
											</ng-container>
										</ng-container>
										<ng-container formArrayName="areaOfToiletCumBathroom">
											<ng-container
												*ngFor="let cotDetail of residentialFormGroup.get('transgenderForm').get('areaOfToiletCumBathroom')['controls']; let areaOfToiletCumBathroomIndex = index ;let lstCotDtails=last">
												<ng-container [formGroupName]="areaOfToiletCumBathroomIndex"
													class="row form-group"></ng-container>
												<div class="row form-group">
													<label class="text-align col-4 ">Area of Toilet Cum Bathroom (in sq.ft)
														{{areaOfToiletCumBathroomIndex+1}}: <span
															class="mandatory">*</span>
													</label>
													<div class="col-8 ">
														<input type="number" disabled
															(change)="areaOfBathroomCumToiletChange('transgender')"
															formControlName="{{areaOfToiletCumBathroomIndex}}"
															onkeypress="return (event.charCode == 8 || event.charCode == 0 ||
																									event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <=
																									57" onpaste="return false" maxlength="4"
															oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
															class="form-control m-input text-side-padding"
															placeholder="Enter Area of Toilet Cum Bathroom in sq.ft.">
														<!-- <span>Minimum Cot Length to be 6 ft</span> -->
														<app-form-control-messages
															[control]="residentialFormGroup.get('transgenderForm').get('areaOfToiletCumBathroom')['controls'][areaOfToiletCumBathroomIndex]"
															[name]="'Area of Toilet Cum Bathroom'">
														</app-form-control-messages>
													</div>
												</div>
											</ng-container>
										</ng-container>
										<app-d-form-group [fnBuffer]="buffer" *ngIf="formDataLoaded"
											[(formData)]="diningAreaFormsTransgender.formData"
											(formLoaded)="onFormLoaded()" [formArray]="diningAreaFormsTransgender.form"
											[defaultValues]="diningAreaFormsTransgender.defaultValue"
											(validChange)="diningAreaFormsTransgender.validity = $event"
											(control)="diningAreaFormsTransgender.control=$event"></app-d-form-group>
										<app-d-form-group [fnBuffer]="buffer" *ngIf="formDataLoaded"
											[(formData)]="diningAreaRecreationalFormsTransgender.formData"
											(formLoaded)="onFormLoaded()"
											[formArray]="diningAreaRecreationalFormsTransgender.form"
											[defaultValues]="diningAreaRecreationalFormsTransgender.defaultValue"
											(validChange)="diningAreaRecreationalFormsTransgender.validity = $event"
											(control)="diningAreaRecreationalFormsTransgender.control=$event">
										</app-d-form-group>
										<ng-container formArrayName="dustbinSizeInDiningAreaRecreationalArea">
											<ng-container
												*ngFor="let cotDetail of residentialFormGroup.get('transgenderForm').get('dustbinSizeInDiningAreaRecreationalArea')['controls']; let dustbinSizeInDiningAreaRecreationalAreaIndex = index ;let lstdustbinSizeInDiningAreaRecreationalArea=last">
												<ng-container
													[formGroupName]="dustbinSizeInDiningAreaRecreationalAreaIndex"
													class="row form-group"></ng-container>
												<div class="row form-group">
													<label class="text-align col-4 ">Dustbin Size (in Ltr)
														{{dustbinSizeInDiningAreaRecreationalAreaIndex+1}}: <span
															class="mandatory">*</span>
													</label>
													<div class="col-8 ">
														<input type="number" disabled
															formControlName="{{dustbinSizeInDiningAreaRecreationalAreaIndex}}"
															onkeypress="return (event.charCode == 8 || event.charCode == 0 ||
																			event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <=
																			57" onpaste="return false" maxlength="4" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
															class="form-control m-input text-side-padding"
															placeholder="Enter Dustbin Size in ltrs.">
														<!-- <span>Minimum Cot Length to be 6 ft</span> -->
														<app-form-control-messages
															[control]="residentialFormGroup.get('transgenderForm').get('dustbinSizeInDiningAreaRecreationalArea')['controls'][dustbinSizeInDiningAreaRecreationalAreaIndex]"
															[name]="'Dustbin Size In Dining Area + Recreational Area'">
														</app-form-control-messages>
													</div>
												</div>
											</ng-container>
										</ng-container>
										<!-- <label  class="kt-checkbox-list col-12">
														<label class="kt-checkbox col-3"><input type="checkbox" [(ngModel)]="sameAsPermanentAddres" [disabled]="!(validity.permanentAddressValid)" (change)="copyPermanentAddress()"/>
														<span></span>
													</label>
													</label> -->


										<div></div>
										<!--subLabel="Address of the Residential Facilities for Transgender"-->
										<div class="form-group m-form__group row">
											<div class="col-10"></div>
											<div class="col-2 col-lg-2 col-md-2 col-sm-12">
												<!-- <button class="btn btn-secondary" data-toggle="modal"
													*ngIf="typeOfResidencialData && typeOfResidencialData.type &&typeOfResidencialData.type.transgender ==true"
													data-backdrop="static" (click)="checkAddRoom('TransGender')"
													data-target="#addRoomForm">Add Rooms <span
														class="mandatory">*</span>
												</button> -->
											</div>
										</div>
									</div>
									<div class="form-group m-form__group table-side-space"
										[hidden]="typeOfResidencialData && typeOfResidencialData.type &&typeOfResidencialData.type.transgender ==false">
										<div class="m-section">
											<div class="m-section__content">
												<div class="m_datatable m-datatable m-datatable--default m-datatable--loaded"
													id="base_responsive_columns" style="position: static; zoom: 1;">
													<table class="table table-striped classroom-table">
														<thead>
															<tr>
																<th style="min-width: 110px;">Room No.</th>
																<th style="min-width: 110px;">Room Area</th>
																<th style="min-width: 110px;">Capacity of Room</th>
																<th style="min-width: 110px;">Ceiling Height</th>
																<th style="min-width: 110px;">Availability of Doors in
																	room</th>
																<th style="min-width: 110px;">Availability of windows in
																	room</th>
																<th style="min-width: 50px!important;">Area Equipped
																	With</th>
																<!-- <th style="min-width: 30px!important;">Delete Room</th> -->
																<th style="min-width: 30px!important;">View</th>
															</tr>
														</thead>
														<tbody>
															<tr *ngFor="let room of transngender;let i = index">
																<td style="min-width: 110px;">Room_{{i+1}}</td>
																<td style="min-width: 110px;">{{room.roomArea}}</td>
																<td style="min-width: 110px;">{{room.capacity}}</td>
																<td style="min-width: 110px;">{{room.ceilingHeight}}
																</td>
																<td style="min-width: 110px;">
																	{{room.availabilityOfDoorAtEntrance==true?'Yes':'No'}}
																</td>
																<td style="min-width: 50px!important;">
																	{{room.availabilityOfWindowCrossVentilation==true?'Yes':'No'}}
																</td>
																<td style="min-width: 30px!important;">
																	{{ room?.areaEquippedWith?.cot ? 'Cot' + ',' : '' }}
																	{{ room?.areaEquippedWith?.matress ? 'Mattress'+ ',' : '' }}
																	{{ room?.areaEquippedWith?.pillow ? 'Pillow'+ ',' : '' }}
																	{{ room?.areaEquippedWith?.trunkWithLock ? 'Trunk with lock'+ ',' : '' }}
																	{{ room?.areaEquippedWith?.cupboardLockingArrangement ? 'Cupboard/Almirah with locking Arrangement'+ ',' : '' }}
																	{{ room?.areaEquippedWith?.ledCFLIncandentLight ? 'LED/CFL/Incandescent light bulb(1000-1400 lumens)'+ ',' : '' }}
																	{{ room?.areaEquippedWith?.ceilingFan ? 'Ceiling Fan'+ ',' : '' }}
																	{{ room?.areaEquippedWith?.plugPoint ? 'Plug Point'+ ',' : '' }}
																	{{ room?.areaEquippedWith?.availabilityOfDedicatedHousekeepingStaff ? 'Availability of dedicated housekeeping staff at the Residential Facility'+ ',' : '' }}
																	{{ room?.areaEquippedWith?.availabilityOfSafeDrinkingWater ? 'Availability of safe/clean drinking water facility in the form of Reverse Osmosis(RO)/Water purifier/Packaged drinking water/Packaged drinking' : '' }}
																	{{ room?.areaEquippedWith?.powerBackUp ? 'Availability of power backup covering basic facilities such as lights and Fans'+ ',' : '' }}
																</td>
																<!-- <td>
																	<a> <i class="la la-trash delete-icon"
																			title="remove"
																			(click)="removeRooom(i,'TransGender')"></i>
																	</a>
																</td> -->
																<td style="min-width: 30px!important;">
																	<a data-backdrop="static" data-target="#addRoomForm"
																		data-toggle="modal"> <i
																			class="la la-edit edit-icon" title="edit"
																			(click)="checkAddRoom('TransGender');editRooom(i,'TransGender')"></i>
																	</a>
																</td>
															</tr>
														</tbody>
														<ng-template #labDataElse>
															<ng-container>
																<tbody class="text-center">
																	<tr class="text-center">No record found</tr>
																</tbody>
															</ng-container>
														</ng-template>
													</table>
												</div>
											</div>
										</div>
									</div>
									<div class="col-md-10" style="padding-left: 50px; padding-top: 29px"
										*ngIf="typeOfResidencialData && typeOfResidencialData.type &&typeOfResidencialData.type.transgender ==true">
										<div class="row form-group cot-spacing">
											<label class="text-align col-4">Total Area for Transgender Residential
												Facility:
												<!-- <span class="mandatory">*</span> -->
											</label>
											<div class="col-8">
												<input type="number" formControlName="totalArea"
													class="form-control m-input text-side-padding" 	> <span>Total
													Area auto calculated</span>
												<!-- <span>Minimum Cot Length to be 6 ft</span> -->
											</div>
										</div>
										<div class="row form-group cot-spacing">
											<label class="text-align col-4">Total Capacity for Transgender Residential
												Facility:
												<!-- <span class="mandatory">*</span> -->
											</label>
											<div class="col-8">
												<input type="number" formControlName="capacity"
													class="form-control m-input text-side-padding" disabled> <span>Total
													Capacity auto calculated</span>
												<!-- <span>Minimum Cot Length to be 6 ft</span> -->
											</div>
										</div>
									</div>
								</ng-container>
							</form>
							<hr>
							<div class=" m-portlet__body row save-next"
								[hidden]="typeOfResidencialData && typeOfResidencialData.type &&typeOfResidencialData.type.transgender ==false">
								<!--[disabled]="!validForTransgender" [disabled]="getTransgenderValidity()"-->
								<div class="col-lg-5 col-md-5 col-sm-12 text-align">
									<button class="btn btn-info"
										(click)="saveAndNext('transgender')">Next</button>
								</div>
								<div class="col-lg-5 col-md-5 col-sm-12">
									<!--<button class="btn btn-secondary" (click)="saveAsDraft()">Save As Draft</button>-->
									<!-- <button class="btn btn-info" (click)="saveAndNext('transgender','saveAsDraft')">Save
										as Draft</button> -->
								</div>
							</div>
						</div>
					</div>

			</div>
		</div>
		<div class="modal fade" id="addRoomForm" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
			style="padding-right: 17px;">
			<div class="modal-dialog modal-lg" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="exampleModalLabel">Add Room Details</h5>
						<button type="button" (click)="closeModal()" class="close" data-dismiss="modal"
							aria-label="Close"> <span aria-hidden="true">×</span>
						</button>
					</div>
					<div class="modal-body padding-top-null padding-bottom-null margin-top-30">
						<app-d-form-group [(formData)]="roomDetails" [fnBuffer]="buffer" *ngIf="formDataLoaded"
							(validChange)="isRoomValid = $event" [formArray]="roomForm" (control)="roomControl=$event">
						</app-d-form-group>
						<!--(change)="onSectorChange(jobRoleInformationForm.get('sector').value)" formControlName="sector"-->
						<hr>
						<form [formGroup]="roomFormGroup">
							<ng-container formArrayName="cotType">
								<ng-container
									*ngFor=" let type of roomFormGroup.get('cotType')['controls']; let idx = index ;let lst=last">
									<ng-container [formGroupName]="idx">
										<div class="row form-group ">
											<label class="col-4 text-align-ment cot-spacing">Type Of Bed: <span
													class="mandatory">*</span>
											</label>
											<div class="select-div col-8 cot-spacing">
												<div class="form-select-side">
													<svg width="10px" height="12px" version="1.1"
														xmlns="http://www.w3.org/2000/svg" viewBox="0 0 129 129"
														enable-background="new 0 0 129 129">
														<g>
															<path
																d="m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z">
															</path>
														</g>
													</svg>
												</div>
												<select class="form-control m-input" id="exampleSelect1"
													(change)="typeOfCotChange(roomFormGroup.get('cotType')['controls'][idx].get('typeOfCot').value,idx)"
													formControlName="typeOfCot" required>
													<option value=null disabled>Select Type of Bed</option>
													<option value="Bed With 1 Stories">Bed With 1 Stories</option>
													<option value="Bunk Bed With 2 stories">Bunk Bed With 2 stories
													</option>
												</select>
												<app-form-control-messages
													[control]="roomFormGroup.get('cotType')['controls'][idx].get('typeOfCot')"
													[name]="'Type of Bed'"></app-form-control-messages>
											</div>
										</div>
										<div class="row form-group">
											<ng-container formArrayName="cotDetails">
												<ng-container
													*ngFor=" let cotDetail of roomFormGroup.get('cotType')['controls'][idx].get('cotDetails')['controls']; let idxCotDtails = index ;let lstCotDtails=last">
													<ng-container [formGroupName]="idxCotDtails" class="row form-group">
														<!-- <div class="row form-group"> -->
														<h5 class="col-4 text-align-ment cot-spacing"> Details of
															Bed/Cot {{idxCotDtails+1}}:</h5>
														<h5 class="col-8"></h5>
														<label class="col-4 text-align-ment cot-spacing">Frame Of Cot:
															<span class="mandatory">*</span>
														</label>
														<div class="select-div col-8  cot-spacing">
															<div class="form-select-side">
																<svg width="10px" height="12px" version="1.1"
																	xmlns="http://www.w3.org/2000/svg"
																	viewBox="0 0 129 129"
																	enable-background="new 0 0 129 129">
																	<g>
																		<path
																			d="m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z">
																		</path>
																	</g>
																</svg>
															</div>
															<select class="form-control m-input" id="exampleSelect1"
																formControlName="frameOfCot" required>
																<option value=null disabled>Select Frame Of Cot</option>
																<option value="Wooden">Wooden</option>
																<option value="Metal">Metal</option>
															</select>
															<app-form-control-messages
																[control]="roomFormGroup.get('cotType')['controls'][idx].get('cotDetails')['controls'][idxCotDtails].get('frameOfCot')"
																[name]="'Frame Of Cot'"></app-form-control-messages>
														</div>
														<!-- </div> -->
														<!-- <div class="row form-group"> -->
														<!-- <label class="text-align col-4"></label> -->
														<label class="text-align col-4 cot-spacing">Cot Length (in ft): <span
																class="mandatory">*</span>
														</label>
														<div class="col-8 cot-spacing">
															<input type="number" formControlName="cotLength" onkeypress="return (event.charCode == 8 || event.charCode == 0 ||
																									event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <=
																									57" onpaste="return false" maxlength="6"
																oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
																class="form-control m-input text-side-padding"
																placeholder="Enter Cot Length in ft."> <span>Minimum Cot
																Length to be 6 ft</span>
															<app-form-control-messages
																[control]="roomFormGroup.get('cotType')['controls'][idx].get('cotDetails')['controls'][idxCotDtails].get('cotLength')"
																[name]="'Cot Length'"
																[errorMessages]="{min: 'Cot Length should not be less than 6 ft'}">
															</app-form-control-messages>
														</div>
														<label class="text-align col-4 cot-spacing">Cot Width (in ft): <span
																class="mandatory">*</span>
														</label>
														<div class="col-8 cot-spacing">
															<input type="number" formControlName="cotWidth" onkeypress="return (event.charCode == 8 || event.charCode == 0 ||
																									event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <=
																									57" onpaste="return false" maxlength="6"
																oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
																class="form-control m-input text-side-padding"
																placeholder="Enter Cot Width in ft."> <span>Minimum Cot
																Width to be 3 ft</span>
															<app-form-control-messages
																[control]="roomFormGroup.get('cotType')['controls'][idx].get('cotDetails')['controls'][idxCotDtails].get('cotWidth')"
																[name]="'Cot Width'"
																[errorMessages]="{min: 'Cot Width should not be less than 3ft'}">
															</app-form-control-messages>
														</div>
														<label class="col-4 text-align-ment cot-spacing">Type of
															Mattress: <span class="mandatory">*</span>
														</label>
														<div class="select-div col-8  cot-spacing">
															<div class="form-select-side">
																<svg width="10px" height="12px" version="1.1"
																	xmlns="http://www.w3.org/2000/svg"
																	viewBox="0 0 129 129"
																	enable-background="new 0 0 129 129">
																	<g>
																		<path
																			d="m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z">
																		</path>
																	</g>
																</svg>
															</div>
															<select class="form-control m-input" id="exampleSelect1"
																(change)="typeOfMatressChange(roomFormGroup.get('cotType')['controls'][idx].get('cotDetails')['controls'][idxCotDtails].get('typeOfMatress').value,idx,idxCotDtails)"
																formControlName="typeOfMatress" required>
																<option value=null disabled>Select Type of Mattress
																</option>
																<option value="Cotton">Cotton</option>
																<option value="Foam">Foam</option>
																<option value="Fiber">Fiber</option>
															</select>
															<app-form-control-messages
																[control]="roomFormGroup.get('cotType')['controls'][idx].get('cotDetails')['controls'][idxCotDtails].get('typeOfMatress')"
																[name]="'Type of Mattress'"></app-form-control-messages>
														</div>
														<label class="col-lg-4 text-align cot-spacing">Mattress
															Thickness (in inches): <span class="mandatory">*</span>
														</label>
														<div class="col-8 cot-spacing">
															<input type="number" onkeypress="return (event.charCode == 8 || event.charCode == 0 ||
																						event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <=
																						57" onpaste="return false" maxlength="6" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
																formControlName="matressThickness"
																class="form-control m-input text-side-padding "
																placeholder="Enter Mattress Thickness in inches">
															<app-form-control-messages
																[control]="roomFormGroup.get('cotType')['controls'][idx].get('cotDetails')['controls'][idxCotDtails].get('matressThickness')"
																[name]="'Mattress Thickness'">
															</app-form-control-messages> <span
																*ngIf="roomFormGroup.get('cotType')['controls'][idx].get('cotDetails')['controls'][idxCotDtails].get('typeOfMatress').value =='Foam'||roomFormGroup.get('cotType')['controls'][idx].get('cotDetails')['controls'][idxCotDtails].get('typeOfMatress').value =='Fiber'">Minimum
																thickness to be 5 inches.</span>
															<span
																*ngIf="roomFormGroup.get('cotType')['controls'][idx].get('cotDetails')['controls'][idxCotDtails].get('typeOfMatress').value =='Cotton'">Minimum
																thickness to be 3 inches.</span>
														</div>
														<!-- </div> -->
														<!-- <div class="row form-group"> -->
														<label class="col-lg-4 text-align cot-spacing">Availability of
															Pillow : <span class="mandatory">*</span>
														</label>
														<div class="col-8 cot-spacing">
															<select class="form-control m-input" id="exampleSelect1"
																formControlName="availabilityOfPillowThickness"
																(change)="availabilityOfPillow(roomFormGroup.get('cotType')['controls'][idx].get('cotDetails')['controls'][idxCotDtails].get('availabilityOfPillowThickness').value,roomFormGroup.get('cotType')['controls'][idx].get('cotDetails')['controls'][idxCotDtails].get('pillowThickness'))"
																required>
																<option value=null disabled>Select Availability of
																	Pillow</option>
																<option [ngValue]="true">Yes</option>
																<option [ngValue]="false">No</option>
															</select>
															<app-form-control-messages
																[control]="roomFormGroup.get('cotType')['controls'][idx].get('cotDetails')['controls'][idxCotDtails].get('availabilityOfPillowThickness')"
																[name]="'Availability of Pillow Thikness'">
															</app-form-control-messages>
														</div>
														<!-- <ng-container *ngIf="roomFormGroup.get('cotType')['controls'][idx].get('cotDetails')['controls'][idxCotDtails].get('availabilityOfPillowThickness').value == true">
																							<label class="col-lg-4 text-align cot-spacing">Pillow Thickness:
																								 <span class="mandatory">*</span>
																							 </label>
																							 <div class="col-8 cot-spacing">
																							 <input type="number" onkeypress="return (event.charCode == 8 || event.charCode == 0 ||
																							 event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <=
																							 57" onpaste="return false" maxlength="6" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" formControlName="pillowThickness"  class="form-control m-input" placeholder="Enter Pillow Thickness in inches">
																						 <app-form-control-messages [control]="roomFormGroup.get('cotType')['controls'][idx].get('cotDetails')['controls'][idxCotDtails].get('pillowThickness')"
																						 [name]="'Pillow Thikness'"></app-form-control-messages>
																					</div>
																				</ng-container> -->
														<!-- <label class="col-lg-4 text-align cot-spacing">Cot With Mattress With Pillow Thickness:
																									<span class="mandatory">*</span>
																								</label>
																								<div class="col-8 cot-spacing">
																								<input type="number" onkeypress="return (event.charCode == 8 || event.charCode == 0 ||
																								event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <=
																								57" onpaste="return false" maxlength="6" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" formControlName="cotMatressPillowThickness"  class="form-control m-input text-side-padding " placeholder="Enter Cot With Mattress With Pillow Thickness in inches">
																						 <app-form-control-messages [control]="roomFormGroup.get('cotType')['controls'][idx].get('cotDetails')['controls'][idxCotDtails].get('cotMatressPillowThickness')"
																																							 [name]="'Cot With Mattress With Pillow Thickness'"></app-form-control-messages>
																						</div>  -->
														<!-- </div> -->
													</ng-container>
												</ng-container>
											</ng-container>
										</div>
										<div class="row form-group cot-spacing" *ngIf="lst">
											<div class="col-8 text-align-ment"></div>
											<div class="col-4 text-align-ment">
												<button
													class="btn btn-outline-accent m-btn m-btn--custom m-btn--outline-2x btn-style"
													[disabled]="this.roomFormGroup.get('cotType')['controls'][idx].invalid"
													(click)="addCotDetails()">Add More Cot/Bunk Bed</button>
											</div>
										</div>
										<ng-container *ngIf="this.roomFormGroup.get('cotType').value.length>1">
											<label class="col-9"></label>
											<label class="col-2">
												<button
													class="btn btn-outline-accent m-btn m-btn--custom m-btn--outline-2x btn-style"
													(click)="removeCotDetails(idx)">Remove Cot/Bunk Bed</button>
											</label>
										</ng-container>
										<hr>
									</ng-container>
								</ng-container>
							</ng-container>
							<ng-container formArrayName="cupBordType">
								<ng-container
									*ngFor=" let cupBordDetail of roomFormGroup.get('cupBordType')['controls']; let idxcupBordType = index ;let lstcupBordType=last">
									<ng-container [formGroupName]="idxcupBordType" class="row form-group">
										<div class="row form-group">
											<!-- <h5 class="col-4 text-align-ment cot-spacing"> Details of Bed/Cot {{idxcupBordType+1}}:</h5> <h5 class="col-8"></h5> -->
											<!-- <div class="row form-group">
																<label class="col-4 text-align-ment cot-spacing">Type Of Storage:
																			<span class="mandatory">*</span>
																		</label>
																		<div class="select-div col-8  cot-spacing">
																				<div class="form-select-side">
																				  <svg width="10px" height="12px" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 129 129" enable-background="new 0 0 129 129">
																					<g>
																					  <path d="m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z"></path>
																					</g>
																				  </svg>
																				</div>
																	<select class="form-control m-input"
																	id="exampleSelect1" formControlName="typeOfCupBoard" (change)="changeTypeOFCupBoard(this.roomFormGroup.get('cupBordType')['controls'][idxcupBordType].value.typeOfCupBoard,idxcupBordType)" required>
																	   <option value=null disabled>Select Type Of Storage</option>
																	   <option  value="Cupboard/Almirah">Cupboard/Almirah With Lock</option>
																	   <option  value="Trunk">Trunk With Lock</option>
																   </select>
																   </div> -->
											<!-- <h2 class="col-4"><b>Volume of Cupboard/Almirah/Trunk:</b></h2> -->
											<!-- <h5 class="text-align col-6"></h5> -->
											<div class="row form-group">
												<label class="col-4 text-align-ment cot-spacing">Type Of Storage:
													<span class="mandatory">*</span>
												</label>
												<div class="select-div col-8  cot-spacing">
													<div class="form-select-side">
														<svg width="10px" height="12px" version="1.1"
															xmlns="http://www.w3.org/2000/svg" viewBox="0 0 129 129"
															enable-background="new 0 0 129 129">
															<g>
																<path
																	d="m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z">
																</path>
															</g>
														</svg>
													</div>
													<select class="form-control m-input" id="exampleSelect1"
														formControlName="typeOfCupBoard"
														(change)="changeTypeOFCupBoard(this.roomFormGroup.get('cupBordType')['controls'][idxcupBordType].value.typeOfCupBoard,idxcupBordType)"
														required>
														<option value=null disabled>Select Type Of Storage</option>
														<option value="Cupboard/Almirah">Cupboard/Almirah With Lock
														</option>
														<option value="Trunk">Trunk With Lock</option>
													</select>
												</div>
												<ng-container formGroupName="volumeOfCupBoardOrTrunk">
													<!-- <div [hidden]="roomFormGroup.get('cupBordType')['controls'][idxcupBordType].get('typeOfCupBoard').value==''"> -->
													<div class="col-4 cot-spacing">
														<label class="text-align">Height of Cupboard/Almirah/Trunk (in sq.ft):
															<span class="mandatory">*</span>
														</label>
														<input type="number" onkeypress="return (event.charCode == 8 || event.charCode == 0 ||
																		event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <=
																		57" onpaste="return false" maxlength="6" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
															class="form-control m-input text-side-padding"
															formControlName="height"
															placeholder="Height of Cupboard/Almirah/Trunk in sq.ft">
														<!-- <span *ngIf="this.roomFormGroup.get('cupBordType')['controls'][idxcupBordType].value.typeOfCupBoard=='Cupboard/Almirah'">Minimum Volume of Cupboard/Almirah (30h*18w*12d) inches 20% deviations allowed</span>
																		<span *ngIf="this.roomFormGroup.get('cupBordType')['controls'][idxcupBordType].value.typeOfCupBoard=='Trunk'">Minimum Volume of Trunk (30h*18w*12d) inches</span> -->
														<app-form-control-messages
															[control]="roomFormGroup.get('cupBordType')['controls'][idxcupBordType].get('volumeOfCupBoardOrTrunk').get('height')"
															[name]="'Height of Cupboard/Almirah/Trunk'">
														</app-form-control-messages>
													</div>
													<div class="col-4 cot-spacing">
														<label class="text-align">Width of Cupboard/Almirah/Trunk (in sq.ft):
															<span class="mandatory">*</span>
														</label>
														<input type="number" onkeypress="return (event.charCode == 8 || event.charCode == 0 ||
																		event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <=
																		57" onpaste="return false" maxlength="6" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
															formControlName="width"
															class="form-control m-input text-side-padding"
															placeholder="Width of Cupboard/Almirah/Trunk in sq.ft">
														<!-- <span *ngIf="this.roomFormGroup.get('cupBordType')['controls'][idxcupBordType].value.typeOfCupBoard=='Cupboard/Almirah'">Minimum Volume of Cupboard/Almirah (30h*18w*12d) inches 20% deviations allowed</span>
																		<span *ngIf="this.roomFormGroup.get('cupBordType')['controls'][idxcupBordType].value.typeOfCupBoard=='Trunk'">Minimum Volume of Trunk (30h*18w*12d) inches</span> -->
														<app-form-control-messages
															[control]="roomFormGroup.get('cupBordType')['controls'][idxcupBordType].get('volumeOfCupBoardOrTrunk').get('width')"
															[name]="'Width of Cupboard/Almirah/Trunk'">
														</app-form-control-messages>
													</div>
													<div class="col-4 cot-spacing">
														<label class="text-align">Depth of Cupboard/Almirah/Trunk (in sq.ft):
															<span class="mandatory">*</span>
														</label>
														<input type="number"
															onkeypress="return (event.charCode == 8 || event.charCode == 0 || 57)"
															onpaste="return false" maxlength="6"
															oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
															formControlName="thickness"
															placeholder="Depth of Cupboard/Almirah/Trunk in sq.ft"
															class="form-control m-input text-side-padding">
														<!-- <span *ngIf="this.roomFormGroup.get('cupBordType')['controls'][idxcupBordType].value.typeOfCupBoard=='Cupboard/Almirah'">Minimum Volume of Cupboard/Almirah (30h*18w*12d) inches 20% deviations allowed</span>
																																									<span *ngIf="this.roomFormGroup.get('cupBordType')['controls'][idxcupBordType].value.typeOfCupBoard=='Trunk'">Minimum Volume of Trunk (30h*18w*12d) inches</span> -->
														<app-form-control-messages
															[control]="roomFormGroup.get('cupBordType')['controls'][idxcupBordType].get('volumeOfCupBoardOrTrunk').get('thickness')"
															[name]="'Thickness of Cupboard/Almirah/Trunk'">
														</app-form-control-messages>
													</div>
													<!-- </div> -->
												</ng-container>
											</div>
											<!-- <div class="col-12 form-group" > -->
											<!--'Cot With Matress With Pillow Thickness'-->
											<div class="col-7 text-align-ment cot-spacing"></div>
											<div class="col-5 text-align-ment cot-spacing" *ngIf="lstcupBordType">
												<button
													class="btn btn-outline-accent m-btn m-btn--custom m-btn--outline-2x btn-style"
													[disabled]="this.roomFormGroup.get('cupBordType')['controls'][idxcupBordType].invalid"
													(click)="addCupBoard()">Add More Volume of
													Cupboard/Almirah/Trunk</button>
											</div>
											<label class="col-7 top-space"
												*ngIf="this.roomFormGroup.get('cupBordType').value.length>1"></label>
											<label class="col-5 top-space"
												*ngIf="this.roomFormGroup.get('cupBordType').value.length>1">
												<button
													class="btn btn-outline-accent m-btn m-btn--custom m-btn--outline-2x btn-style"
													(click)="removeStorage(idxcupBordType)">Remove Volume of
													Cupboard/Almirah/Trunk</button>
											</label>
											<!-- </div> -->
										</div>
									</ng-container>
								</ng-container>
							</ng-container>
							<!-- <div class="row form-group m-form__group">
					<label class="col-lg-4 text-align">Number of Cot:
						<span class="mandatory">*</span>
					</label>
					<input type="number" formControlName="numberOfCots" (blur)="addCotSize(this.roomFormGroup.value.numberOfCots)" class="form-control m-input col-lg-8" placeholder="Enter Number of Cot">
				</div>
				<ng-container formArrayName="cotSize">
				<ng-container  *ngFor=" let emp of roomFormGroup.get('cotSize')['controls']; let idx = index ;let lst=last">
				<ng-container [formGroupName]="idx">
				<div class="row form-group m-form__group cot-left-padding">
					<div class="col-lg-6">
							<label class="text-align">Cot Height:
								<span class="mandatory">*</span>
							</label>
							<input type="number" formControlName="cotHeight" class="form-control m-input col-lg-12" placeholder="Enter Number of Cot">
					</div>
					<div class="col-lg-6">
							<label class="text-align">Cot Width:
							<span class="mandatory">*</span>
							</label>
							<input type="number" formControlName="cotWidth"  class="form-control m-input col-lg-12" placeholder="Enter Number of Cot">
					</div>
				</div>
			</ng-container>
			</ng-container>
			</ng-container> -->
							<!-- <div class="row form-group m-form__group">
					<label class="col-lg-4 text-align">Number of Cupboard/Almirah with locking :
						<span class="mandatory">*</span>
					</label>
					<input type="number" formControlName="numberOfCupboardAndAlmirah" (blur)="addCupBoradAlmirahSize(this.roomFormGroup.value.numberOfCupboardAndAlmirah)" class="form-control m-input col-lg-8" placeholder="Enter Number of Cot">
				</div>
				<ng-container formArrayName="volumeOfCupboard">
				<ng-container  *ngFor=" let emp of roomFormGroup.get('volumeOfCupboard')['controls']; let idx = index ;let lst=last">
				<ng-container [formGroupName]="idx">
				<div class="row form-group m-form__group ">
					<div class="col-lg-4">
							<label class="text-align">Cupboard/Almirah Length:
								<span class="mandatory">*</span>
							</label>
							<input type="number" formControlName="cubBordLength" class="form-control m-input col-lg-12" placeholder="Enter Number of Cot">
					</div>
					<div class="col-lg-4">
							<label class="text-align">Cupboard/Almirah Width:
							<span class="mandatory">*</span>
							</label>
							<input type="number" formControlName="cubBordWidth"  class="form-control m-input col-lg-12" placeholder="Enter Number of Cot">
					</div>
					<div class="col-lg-4">
							<label class="text-align">Cupboard/Almirah Breadth:
							<span class="mandatory">*</span>
							</label>
							<input type="number" formControlName="cupBordBreadth"  class="form-control m-input col-lg-12" placeholder="Enter Number of Cot">
					</div>
				</div>
			</ng-container>
			</ng-container>
			</ng-container> -->
						</form>
						<!-- [(formData)]="hybridDetails"(validChange)="validity.hybridDetailsFormValid = $event" (control)="hybridCntol=$event"   (formDataChange)="onCompleteChange($event)"<app-add-course-to-sector [resetVersion]="resetVersion" [label]="sectorLabel" [(sectors)]="sectors" (verify)="addCourseToSector($event)"></app-add-course-to-sector> -->
					</div>
					<div class="modal-footer">
						<button type="button" (click)="closeModal()" class="btn btn-secondary">View</button>
						<!-- <button type="button" (click)="addRoom(this.roomIndex)"
							[disabled]="!isRoomValid||this.roomFormGroup.get('cupBordType').invalid||this.roomFormGroup.get('cotType').invalid"
							class="btn btn-primary blue-btn">Add</button> -->
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
<app-display-result *ngIf="sweetAlert" [message]="sweetAlert" (responseMessage)="responseMessageFromAlert($event)"></app-display-result>
